export default __webpack_public_path__ + "static/media/36I-102793_-15929_0.821342af.jpg";